import React, { Component } from 'react';
import { Icon, Select } from 'antd';

import './RegistrationYearFilter.css';

import { observer, inject } from 'mobx-react';

import { isFunction } from 'lodash';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class RegistrationYearFilter extends Component {
  keyStorageMin = `carFilter_minRegYear`;
  keyStorageMax = `carFilter_maxRegYear`;

  constructor(props) {
    super(props);
    let defaultState = {
      // regYears: [],
      selectedMinRegYears: null,
      selectedMaxRegYears: null
    };
    const { filterStore } = this.props;
    let { selectedMinRegYears } = filterStore.appliedFiltersParameters[this.keyStorageMin] || {};
    let { selectedMaxRegYears } = filterStore.appliedFiltersParameters[this.keyStorageMax] || {};
    if (selectedMinRegYears !== undefined || selectedMaxRegYears !== undefined) {
      defaultState = { ...defaultState, selectedMinRegYears, selectedMaxRegYears };
    }
    this.state = defaultState;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  selectMinRegYear = minRegYear => {
    this.setState({ selectedMinRegYears: minRegYear }, () => {
      if (minRegYear) {
        this.props.filterStore.add('carFilter_minRegYear', car => car.registrationYear >= minRegYear, undefined, {
          selectedMinRegYears: minRegYear
        });
      } else {
        this.props.filterStore.remove('carFilter_minRegYear');
      }
    });
  };

  selectMaxRegYear = maxRegYear => {
    this.setState({ selectedMaxRegYears: maxRegYear }, () => {
      if (this.state.selectedMinRegYears) {
        let conditionMin = Number.isInteger(this.state.minRegYearSelected) ? car => car.registrationYear >= this.state.minRegYearSelected : () => true;
        let conditionMax = Number.isInteger(maxRegYear) ? car => car.registrationYear <= maxRegYear : () => true;
        this.props.filterStore.add('carFilter_maxRegYear', car => conditionMin(car) && conditionMax(car), undefined, {
          selectedMaxRegYears: this.state.selectedMaxRegYears
        });
      } else if (maxRegYear) {
        this.props.filterStore.add('carFilter_maxRegYear', car => car.registrationYear <= maxRegYear, undefined, {
          selectedMaxRegYears: maxRegYear
        });
      } else {
        this.props.filterStore.remove('carFilter_maxRegYear');
      }
    });
  };

  removeRegistrationYear = () => {
    this.setState({ selectedMinRegYears: null, selectedMaxRegYears: null });
    this.props.filterStore.remove('carFilter_minRegYear');
    this.props.filterStore.remove('carFilter_maxRegYear');
    this.props.filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        selectedMinRegYears: null,
        selectedMaxRegYears: null
      });
    }
  };

  render() {
    const { selectedMinRegYears, selectedMaxRegYears } = this.state;
    const { translationsStore, carsStore } = this.props;
    return (
      <div id="regYearFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.registrationYear')}
          <span>
            {!!selectedMinRegYears && <span>{selectedMinRegYears}</span>}
            {!!selectedMaxRegYears && (
              <span>
                &nbsp;-&nbsp;
                {selectedMaxRegYears}
              </span>
            )}
            {(!!selectedMinRegYears || !!selectedMaxRegYears) && <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeRegistrationYear} />}
          </span>
        </div>
        <span>
          <Select value={this.state.selectedMinRegYears} getPopupContainer={() => document.getElementById('regYearFilter')} onChange={this.selectMinRegYear}>
            {carsStore.registrationYears.map(year => (
              <Select.Option key={year} value={year} disabled={selectedMaxRegYears && year > selectedMaxRegYears}>
                {year}
              </Select.Option>
            ))}
          </Select>
          <Select value={this.state.selectedMaxRegYears} getPopupContainer={() => document.getElementById('regYearFilter')} onChange={this.selectMaxRegYear}>
            {carsStore.registrationYears.map(year => (
              <Select.Option key={year} value={year} disabled={selectedMinRegYears && year < selectedMinRegYears}>
                {year}
              </Select.Option>
            ))}
          </Select>
        </span>
      </div>
    );
  }
}
